// components/tabs/VaultTab.jsx
import { useState } from 'react';
import { EmptyState, Icons } from '../UI';
import { DOC_TYPES, fmtDate } from '../../utils/constants';

export default function VaultTab({ contract, saveDoc, toast }) {
  const [copied, setCopied] = useState(null);
  const docs = contract.documents || {};

  function copy(id, content) {
    navigator.clipboard.writeText(content);
    setCopied(id);
    toast.success('Copied to clipboard');
    setTimeout(() => setCopied(null), 2000);
  }

  function markFinal(type, doc) {
    saveDoc(type, doc.content, 'final');
  }

  const hasAny = Object.values(docs).some(arr => arr && arr.length > 0);

  return (
    <div>
      {!hasAny ? (
        <div className="card">
          <EmptyState icon="⊘" title="Vault is empty"
            subtitle="Drafts and documents generated in the Penny tab are saved here. Use Save to Vault buttons when reviewing drafted content." />
        </div>
      ) : (
        Object.entries(DOC_TYPES).map(([key, label]) => {
          const typeDocs = docs[key] || [];
          if (typeDocs.length === 0) return null;
          return (
            <div key={key} className="card">
              <h3 className="card-title">{label}</h3>
              <div>
                {[...typeDocs].reverse().map(doc => (
                  <div key={doc.id} style={{ padding: '12px 0', borderBottom: '1px solid var(--slate-100)' }}>
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                          <span className={`doc-tag ${doc.type === 'final' ? 'doc-tag-final' : 'doc-tag-draft'}`}>
                            {doc.type === 'final' ? 'Final' : 'Draft'}
                          </span>
                          <span style={{ fontSize: 12.5, fontWeight: 500 }}>{doc.label}</span>
                          <span style={{ fontSize: 11, color: 'var(--slate-400)', fontFamily: 'var(--font-mono)' }}>{fmtDate(doc.date)}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                          <button className="btn btn-xs btn-ghost" onClick={() => copy(doc.id, doc.content)}>
                            {copied === doc.id ? <><Icons.check /> Copied</> : <><Icons.copy /> Copy</>}
                          </button>
                          {doc.type === 'draft' && (
                            <button className="btn btn-xs btn-success" onClick={() => markFinal(key, doc)}>
                              Mark Final
                            </button>
                          )}
                        </div>
                      </div>
                      {doc.refs && doc.refs.length > 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginTop: 7 }}>
                          <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', color: 'var(--slate-400)' }}>
                            References:
                          </span>
                          {doc.refs.map((ref, i) => (
                            <span key={i} style={{
                              fontSize: 10.5, padding: '2px 8px',
                              background: 'var(--teal-50)', border: '1px solid var(--teal-100)',
                              borderRadius: 'var(--r-full)', color: 'var(--teal-600)', fontWeight: 500,
                            }}>{ref}</span>
                          ))}
                        </div>
                      )}
                    </div>
                    <div style={{
                      background: 'var(--slate-50)', border: '1px solid var(--slate-200)',
                      borderRadius: 'var(--r-md)', padding: '12px 14px',
                      fontSize: 12.5, lineHeight: 1.7, whiteSpace: 'pre-wrap', color: 'var(--slate-700)',
                      maxHeight: 300, overflowY: 'auto',
                    }}>
                      {doc.content.slice(0, 1200)}{doc.content.length > 1200 ? '\n\n[…content truncated — copy to see full text]' : ''}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
